import script from "./BadgeNumberExercise.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgeNumberExercise.vue?vue&type=script&setup=true&lang=js"

import "./BadgeNumberExercise.vue?vue&type=style&index=0&id=786d9b75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786d9b75"]])

export default __exports__